'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { QuantityPicker } from '../product-details';
import { type MiniPdpQuantityProps, useMiniPdpQuantity } from './model/use-mini-pdp-quantity';
import type { MiniPdpForm } from './types';
export function MiniPdpQuantity(props) {
  const $ = _c(12);
  const {
    control
  } = useFormContext();
  const {
    items,
    disabled,
    fulfilmentMethod,
    selectedSku,
    shouldRender
  } = useMiniPdpQuantity(props);
  let t0;
  if ($[0] !== control) {
    t0 = {
      name: "quantity",
      control
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    field
  } = useController(t0);
  if (!shouldRender) {
    return null;
  }
  const t1 = String(field.value);
  const t2 = `${selectedSku}-${fulfilmentMethod}`;
  let t3;
  if ($[2] !== field) {
    t3 = event => field.onChange(Number(event.target.value));
    $[2] = field;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== disabled || $[5] !== field.name || $[6] !== field.onBlur || $[7] !== items || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <QuantityPicker items={items} disabled={disabled} value={t1} key={t2} name={field.name} onChange={t3} onBlur={field.onBlur} testId="mini-pdp-quantity-selector" />;
    $[4] = disabled;
    $[5] = field.name;
    $[6] = field.onBlur;
    $[7] = items;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}